import API_URL from '../config/api';

export interface ShopCustomer {
  id: string | number;
  name: string;
  email: string;
  customer_type: string;
  phone?: string;
  address?: string;
  city?: string;
  postcode?: string;
  country?: string;
}

export function isWholesaleShopCustomer(value: unknown): boolean {
  const v = String(value || '').trim().toLowerCase();
  return v === 'wholesale';
}

export function readShopCustomer(businessId: string): ShopCustomer | null {
  try {
    const raw = localStorage.getItem(`shopCustomer_${businessId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function readShopToken(businessId: string): string | null {
  return localStorage.getItem(`shopToken_${businessId}`);
}

export function saveShopSession(businessId: string, token: string, customer: ShopCustomer) {
  localStorage.setItem(`shopToken_${businessId}`, token);
  localStorage.setItem(`shopCustomer_${businessId}`, JSON.stringify(customer));
}

export function clearShopSession(businessId: string) {
  localStorage.removeItem(`shopToken_${businessId}`);
  localStorage.removeItem(`shopCustomer_${businessId}`);
}

/** Refresh portal session from CRM — picks up Retail → Wholesale changes without re-login */
export async function syncShopSession(businessId: string): Promise<{ token: string; customer: ShopCustomer } | null> {
  const token = readShopToken(businessId);
  if (!token) return null;

  try {
    const res = await fetch(`${API_URL}/shop-auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      if (res.status === 401) clearShopSession(businessId);
      return null;
    }
    const data = await res.json();
    const customer = data.customer || data;
    const freshToken = data.token || token;
    const session = {
      token: freshToken,
      customer: {
        id: customer.id,
        name: customer.name,
        email: customer.email,
        customer_type: customer.customer_type || 'Retail',
        phone: customer.phone,
        address: customer.address,
        city: customer.city,
        postcode: customer.postcode,
        country: customer.country,
      },
    };
    saveShopSession(businessId, session.token, session.customer);
    return session;
  } catch {
    return null;
  }
}
